export default {
  created() {
    this.getBanners();
  },

  data() {
    return {
      bannerList: []
    };
  },

  methods: {
    async getBanners() {
      const bannerList = await this.$http.getBannerList();
      this.bannerList = bannerList; // this.bannerList = [{
      //   "id": "123123",
      //   "file_url": "https://image.zhihuishu.com/zhs/b2cm/base1/202408/4835f55e545d4c3d871ace6d621af9ec.png",
      //   "target_type": 0,
      //   "target_url": null
      // },]
    },

    getBannerUrl(target_type, target_url, id) {
      if (!target_url) return;

      switch (target_type) {
        case 1:
        case 3:
          target_url && window.open(target_url);
          break;

        case 2:
          window.location.href = `/${$schoolUrl}/bannerDetail.html?bannerCon=${id}`;

        default:
          break;
      }
    }

  }
};